// extracted by mini-css-extract-plugin
module.exports = {"CommentForm":"CommentCreateEditForm_CommentForm__3j3yT"};